import { gql } from '@apollo/client';

export const FETCH_DRIVER_SERVICES = gql`
  query FetchDriverServices($id: ID!) {
    driver(id: $id) {
      id
      services {
        id
        type
        status
        driver {
          received
        }
        alternateDriver {
          received
        }
        departure {
          date
        }
      }
    }
  }
`;

export const FETCH_DRIVING_COMPANIES = gql`
  query FetchDrivingCompanies {
    drivingCompanies {
      id
      volcanoId
      name
      phone
      email
    }
  }
`;

export const FETCH_DRIVER_INFO = gql`
  query FetchDriverInfo($id: ID!) {
    driver(id: $id) {
      id
      volcanoDriverId
      email
      name
      phone
      alternatePhone
      type
      status
      loginMethod
      loginEnabled
      profilePicURI
      drivingCompany {
        id
        name
        phone
        email
      }
    }
  }
`;

export const FETCH_ALL_DRIVERS_LIST = gql`
  query FetchAllDrivers {
    drivers {
      id
      volcanoDriverId
      firebaseId
      loginMethod
      type
      status
      notificationsToken
      volcanoEmail
      email
      phone
      alternatePhone
      name
      hasLoginCredentials
      inPrisma
      inVolcano
    }
  }
`;
